import { Directive, Input, TemplateRef, ViewContainerRef, OnInit, inject } from '@angular/core';
import { UserService } from 'src/app/shared/services/user.service';

@Directive({ selector: '[appHideIfNoPermission]' })
export class HideIfNoPermissionDirective implements OnInit {
    private readonly templateRef = inject<TemplateRef<any>>(TemplateRef);
    private readonly vcr = inject(ViewContainerRef);

    private readonly userSvc = inject(UserService);

    @Input('appHideIfNoPermission') permission!: string | string[];

    ngOnInit(): void {
        const hasPermission = Array.isArray(this.permission)
            ? this.userSvc.hasPermissions(this.permission)
            : this.userSvc.hasPermission(this.permission);

        if (hasPermission) {
            this.vcr.createEmbeddedView(this.templateRef);
        } else {
            this.vcr.clear();
        }
    }
}
